/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SearchResultRequestDTOFromJSON, SearchResultRequestDTOToJSON, } from './SearchResultRequestDTO';
/**
 * Check if a given object implements the MoveToProductStagingRequestDTO interface.
 */
export function instanceOfMoveToProductStagingRequestDTO(value) {
    return true;
}
export function MoveToProductStagingRequestDTOFromJSON(json) {
    return MoveToProductStagingRequestDTOFromJSONTyped(json, false);
}
export function MoveToProductStagingRequestDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'selectAll': json['selectAll'] == null ? undefined : json['selectAll'],
        'searchResultIds': json['searchResultIds'] == null ? undefined : json['searchResultIds'],
        'filters': json['filters'] == null ? undefined : SearchResultRequestDTOFromJSON(json['filters']),
    };
}
export function MoveToProductStagingRequestDTOToJSON(json) {
    return MoveToProductStagingRequestDTOToJSONTyped(json, false);
}
export function MoveToProductStagingRequestDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'selectAll': value['selectAll'],
        'searchResultIds': value['searchResultIds'],
        'filters': SearchResultRequestDTOToJSON(value['filters']),
    };
}
